//src/components/TradersSidebar.jsx
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const SidebarContainer = styled.div`
  width: 220px;
  position: fixed;
  top: 60px;
  left: 0;
  height: calc(100vh - 60px);
  overflow-y: auto;
  border-right: 2px solid #ccc;
  background: #f9f9f9;
  padding: 1rem;
  z-index: 1000;

  @media only screen and (max-width: 768px) {
    width: 75%;
    max-width: 280px;
    transform: translateX(${(props) => (props.open ? "0" : "-100%")});
    transition: transform 0.3s ease;
    z-index: 1500;
    box-shadow: ${(props) =>
      props.open ? "4px 0 10px rgba(0,0,0,0.2)" : "none"};
  }
`;

const OvalButton = styled(Link)`
  display: block;
  margin-bottom: 12px;
  padding: 10px 16px;
  border-radius: 30px;
  background: #e0e0e0;
  text-align: center;
  text-decoration: none;
  color: #333;
  border: 1px solid #bbb;

  &:hover {
    background: #d4d4d4;
    transform: translateX(4px);
  }
`;

export default function TradersSidebar({ open, onClose }) {
  const handleClick = () => {
    if (onClose) onClose();
  };

  return (
    <SidebarContainer open={open}>
      <OvalButton to="/traders/Chinese6" onClick={handleClick}>
        📐 Kitchen tools
      </OvalButton>
      <OvalButton to="/traders/Chinese5" onClick={handleClick}>
        📘 Plastic items
      </OvalButton>
      <OvalButton to="/traders/Chinese4" onClick={handleClick}>
        ➕ Hair accessories
      </OvalButton>
      <OvalButton to="/traders/Chinese3" onClick={handleClick}>
        📊 Cleaning tools
      </OvalButton>
      <OvalButton to="/traders/Chinese2" onClick={handleClick}>
        🔢 Home decoration
      </OvalButton>
      <OvalButton to="/traders/Chinese1" onClick={handleClick}>
        👨‍👩‍👧 Stationery
      </OvalButton>
    </SidebarContainer>
  );
}
